// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-classroom-styles {
  font-family: Plus Jakarta Sans;
  font-size: 14px !important;
  font-weight: 600 !important;
  line-height: 40px !important;
  letter-spacing: -0.004em;
  padding: 0px 16px 0px 16px !important;
  color: #564ffd !important;
  background-color: #ebebff !important;
  border-color: #ebebff !important;
}

.start-classroom-styles:hover {
  color: white !important;
  background-color: #564ffd !important;
}

.complete-percentage-styles {
  font-family: Plus Jakarta Sans;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 20px !important;
  letter-spacing: -0.01em;
  text-align: left !important;
  color: #23bd33;
}

.classroom-card {
  background-color: white;
  border: 1px solid #e9eaf0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.classroom-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.classroom-card-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  background: #f5f5f5;
}

.classroom-card-content {
  padding: 18px 16px 10px 16px;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.classroom-card-category {
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  color: #993d20;
  background: #ffeee8;
  padding: 5px 10px;
  border-radius: 4px;
  display: inline-block;
  margin-bottom: 8px;
}

.classroom-card-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: #1d2026;
  margin-bottom: 0;
  word-break: break-word;
}

.classroom-card-footer {
  padding: 12px 16px 16px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

@media (max-width: 1200px) {
  .classroom-card-content {
    padding: 14px 12px 8px 12px;
  }
  .classroom-card-footer {
    padding: 10px 12px 12px 12px;
  }
}
@media (max-width: 1324px) {
  .start-classroom-styles {
    font-size: 9px !important;
    padding: 5px 10px !important;
    min-width: 70px;
    line-height: 20px !important;
  }
  .classroom-card {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  }
  .classroom-card-content {
    padding: 10px 8px 6px 8px;
  }
  .classroom-card-category {
    font-size: 7px;
    padding: 2px 4px;
    margin-bottom: 2px;
  }
  .classroom-card-title {
    font-size: 9px;
    line-height: 15px;
  }
  .classroom-card-footer {
    padding: 8px 8px 10px 8px;
    gap: 6px;
  }
  .summary-card-1024 {
    display: flex;
    align-items: center;
    padding: 10px 8px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    min-height: 60px;
    height: 100%;
  }
  .summary-card-number-1024 {
    font-size: 14px;
    font-weight: 600;
    color: #1d2026;
    line-height: 20px;
  }
  .summary-card-desc-1024 {
    font-size: 10px;
    color: #4e5566;
    line-height: 16px;
    font-weight: 400;
    letter-spacing: -0.01em;
  }
}
@media (max-width: 768px) {
  .classroom-card-content {
    padding: 8px 4px 4px 4px;
  }
  .classroom-card-title {
    font-size: 12px;
    line-height: 16px;
  }
  .classroom-card-footer {
    padding: 6px 4px 8px 4px;
    gap: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Classroom/StudentClassroom/styles.scss"],"names":[],"mappings":"AAAA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,qCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gCAAA;AACF;;AAEA;EACE,uBAAA;EACA,oCAAA;AACF;;AAEA;EACE,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,2BAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,yCAAA;EACA,gBAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,4BAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,2BAAA;EACF;EACA;IACE,4BAAA;EACF;AACF;AAEA;EACE;IACE,yBAAA;IACA,4BAAA;IACA,eAAA;IACA,4BAAA;EAAF;EAEA;IACE,yCAAA;EAAF;EAEA;IACE,yBAAA;EAAF;EAEA;IACE,cAAA;IACA,gBAAA;IACA,kBAAA;EAAF;EAEA;IACE,cAAA;IACA,iBAAA;EAAF;EAEA;IACE,yBAAA;IACA,QAAA;EAAF;EAEA;IACE,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yCAAA;IACA,gBAAA;IACA,YAAA;EAAF;EAEA;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,iBAAA;EAAF;EAEA;IACE,eAAA;IACA,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,uBAAA;EAAF;AACF;AAGA;EACE;IACE,wBAAA;EADF;EAGA;IACE,eAAA;IACA,iBAAA;EADF;EAGA;IACE,wBAAA;IACA,QAAA;EADF;AACF","sourcesContent":[".start-classroom-styles {\n  font-family: Plus Jakarta Sans;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n  line-height: 40px !important;\n  letter-spacing: -0.004em;\n  padding: 0px 16px 0px 16px !important;\n  color: #564ffd !important;\n  background-color: #ebebff !important;\n  border-color: #ebebff !important;\n}\n\n.start-classroom-styles:hover {\n  color: white !important;\n  background-color: #564ffd !important;\n}\n\n.complete-percentage-styles {\n  font-family: Plus Jakarta Sans;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  line-height: 20px !important;\n  letter-spacing: -0.01em;\n  text-align: left !important;\n  color: #23bd33;\n}\n\n.classroom-card {\n  background-color: white;\n  border: 1px solid #e9eaf0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  transition: box-shadow 0.2s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n}\n\n.classroom-card:hover {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);\n}\n\n.classroom-card-img {\n  width: 100%;\n  height: 220px;\n  object-fit: cover;\n  background: #f5f5f5;\n}\n\n.classroom-card-content {\n  padding: 18px 16px 10px 16px;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.classroom-card-category {\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 14px;\n  color: #993d20;\n  background: #ffeee8;\n  padding: 5px 10px;\n  border-radius: 4px;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n\n.classroom-card-title {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  color: #1d2026;\n  margin-bottom: 0;\n  word-break: break-word;\n}\n\n.classroom-card-footer {\n  padding: 12px 16px 16px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n@media (max-width: 1200px) {\n  .classroom-card-content {\n    padding: 14px 12px 8px 12px;\n  }\n  .classroom-card-footer {\n    padding: 10px 12px 12px 12px;\n  }\n}\n\n@media (max-width: 1324px) {\n  .start-classroom-styles {\n    font-size: 9px !important;\n    padding: 5px 10px !important;\n    min-width: 70px;\n    line-height: 20px !important;\n  }\n  .classroom-card {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);\n  }\n  .classroom-card-content {\n    padding: 10px 8px 6px 8px;\n  }\n  .classroom-card-category {\n    font-size: 7px;\n    padding: 2px 4px;\n    margin-bottom: 2px;\n  }\n  .classroom-card-title {\n    font-size: 9px;\n    line-height: 15px;\n  }\n  .classroom-card-footer {\n    padding: 8px 8px 10px 8px;\n    gap: 6px;\n  }\n  .summary-card-1024 {\n    display: flex;\n    align-items: center;\n    padding: 10px 8px;\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    min-height: 60px;\n    height: 100%;\n  }\n  .summary-card-number-1024 {\n    font-size: 14px;\n    font-weight: 600;\n    color: #1d2026;\n    line-height: 20px;\n  }\n  .summary-card-desc-1024 {\n    font-size: 10px;\n    color: #4e5566;\n    line-height: 16px;\n    font-weight: 400;\n    letter-spacing: -0.01em;\n  }\n}\n\n@media (max-width: 768px) {\n  .classroom-card-content {\n    padding: 8px 4px 4px 4px;\n  }\n  .classroom-card-title {\n    font-size: 12px;\n    line-height: 16px;\n  }\n  .classroom-card-footer {\n    padding: 6px 4px 8px 4px;\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
